import type { CSSProperties, ComponentProps } from 'react';

import { cn } from '../cn';

type GridProps = ComponentProps<'div'> & {
  gap: number;
  columns: number;
  columnMinWidth: number;
  columnMaxWidth?: number;
};

export const ColumnsGrid = ({
  children,
  gap,
  columns,
  columnMinWidth,
  columnMaxWidth,
  className,
  style,
  ...props
}: GridProps) => {
  const itemMaxWidth =
    columnMaxWidth != null
      ? `${columnMaxWidth}px`
      : `calc((100% - ${(columns - 1) * gap}px) / ${columns})`;
  const gridStyle: CSSProperties = {
    gridTemplateColumns: `repeat(auto-fill, minmax(max(${columnMinWidth}px, ${itemMaxWidth}), 1fr))`,
    gap: `${gap}px`,
    ...style,
  };
  return (
    <div className={cn('grid', className)} style={gridStyle} {...props}>
      {children}
    </div>
  );
};
